module.exports = __webpack_public_path__ + "img/decors.f4c61052.png";